import { useEffect, useState } from "react";
import logo from "../assets/img/logo.png";
import { Link, useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword, updateProfile, signOut } from "firebase/auth";
import { auth } from "../firebase";

const Signup = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [phone, setPhone] = useState(null); // Hidden by default
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const navigate = useNavigate();

    useEffect(() => {
        const yearSpan = document.getElementById("year");
        if (yearSpan) {
            yearSpan.textContent = new Date().getFullYear();
        }
    }, []);

    const handleSignup = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        try {
            // ✅ Create account in Firebase
            const userCredential = await createUserWithEmailAndPassword(auth, email, password);

            // ✅ Update user displayName
            await updateProfile(userCredential.user, {
                displayName: name,
            });

            setSuccess("Account created successfully!");

            // ✅ Force sign out
            await signOut(auth);

            // ✅ Navigate to signin page
            navigate("/signin");
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div
            style={{
                background: "linear-gradient(to bottom right, #007bff, #0056b3)",
                height: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                margin: 0,
            }}
        >
            <div className="logo text-center mb-3">
                <img src={logo} alt="MReloadpay Logo" style={{ width: "100px" }} />
            </div>

            <div
                className="signin-card"
                style={{
                    background: "rgba(255, 255, 255, 0.9)",
                    padding: "20px",
                    borderRadius: "15px",
                    width: "100%",
                    maxWidth: "400px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                }}
            >
                <h2 className="text-center" style={{ color: "#0056b3", fontSize: "20px", fontWeight: "bold" }}>
                    Create Account
                </h2>

                {error && <div className="alert alert-danger">{error}</div>}
                {success && <div className="alert alert-success">{success}</div>}

                <form onSubmit={handleSignup}>
                    <div className="mb-2">
                        <label htmlFor="name" className="form-label">Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="name"
                            placeholder="Enter your name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>

                    <div className="mb-2">
                        <label htmlFor="email" className="form-label">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>

                    <div className="mb-2">
                        <label htmlFor="password" className="form-label">Password</label>
                        <input
                            type="password"
                            className="form-control"
                            id="password"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    {/* ✅ Optional phone field */}
                    {phone !== null && (
                        <div className="mb-2">
                            <label htmlFor="phone" className="form-label">Phone</label>
                            <input
                                type="tel"
                                className="form-control"
                                id="phone"
                                placeholder="Enter phone number"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                            />
                        </div>
                    )}

                    <div className="d-grid">
                        <button type="submit" className="btn btn-primary">Create Account</button>
                    </div>
                </form>

                <p className="text-center pt-2">
                    <Link to="/signin" className="text-decoration-none">Sign in</Link>
                </p>
            </div>

            <div className="footer" style={{ marginTop: "20px", textAlign: "center", color: "#ffffffcc", fontSize: "14px" }}>
                © <span id="year"></span>, MReloadpay
            </div>
        </div>
    );
};

export default Signup;
